import axios from "axios";
import axiosInstance from "./axiosInstance";
import {CreateHashTagFormProps} from "../types/ComponentProps";

const createHashTag = async (formData: CreateHashTagFormProps) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const data = await axiosInstance.post("/api/createHashTag", formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message =
        error.response?.data?.message || "An unexpected error occurred.";
      throw new Error(message);
    } else {
      throw new Error("An unexpected error occurred.");
    }
  }
};

export default createHashTag;
